import React from 'react'
import "./login.css"
import { Link } from 'react-router-dom'
const Login = () => {
  return (
    <div className='content'>
      <div className='auth'>
        <h1>Login</h1>
        <form>
          <input required type='text' placeholder='username'/>
          <input required type='password' placeholder='password'/>
          <button className='btnLogin'>Login</button>
          <p>Error Message!!!!</p>
          <span>Don't you have an account ? <Link to="/register">Register</Link>
          </span>
        </form>
      </div>
    </div>
  )
}

export default Login
